"use clent";

import React from "react";
import "./styles.css";
import "../common.css";

export const InfoUnit = ({
	title,
	text = [
		"Lorem ipsum dolor sit amet.",
		"Qui commodi nostrum eos soluta consequatur et ipsam assumenda",
		" Non praesentium nulla rem",
		"Molestias in natus unde ut facilis voluptates",
	],
	textColor = "#242323",
	picture,
	picture2,
	pictureAlt,
}) => {
	return (
		<div className="infowrapper" style={{ color: textColor }}>
			<div className="textblock">
				{title && <h2 className="infotitle">{title}</h2>}
				{text.map((unit) => (
					<div>{unit}</div>
				))}
			</div>

			{picture2 ? (
				<div className="pictures__grid">
					<img src={picture} alt="" />
					<img src={picture2} alt="" />
				</div>
			) : picture ? (
				<img src={picture} alt={pictureAlt} className="infopicture" />
			) : (
				<></>
			)}
		</div>
	);
};
